import { useGetAccounts } from '@api/lendingAPI/lapiHooks';
import { FormattedMessage } from 'react-intl';

import { FundingProgressStep } from './FundingProgressStep/FundingProgressStep';

export const FundingProgressIndicator = ({ step }: { step: number }) => {
    const { data, isLoading, isError } = useGetAccounts();

    if (isLoading || isError || !data?.accounts?.length) return null;

    const isTopup = data?.accounts?.some(
        (acc) => acc.loan_status && acc.loan_status !== 'ended'
    );

    const STEPS_CONFIG = [
        {
            id: 1,
            label: 'Application',
            message: (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.application"
                    defaultMessage="Application"
                />
            )
        },
        {
            id: 2,
            label: isTopup ? 'Select amount' : 'My Offers',
            message: isTopup ? (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.select_amount"
                    defaultMessage="Select amount"
                />
            ) : (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.my_offers"
                    defaultMessage="My Offers"
                />
            )
        },
        {
            id: 3,
            label: 'Final checks',
            message: (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.final_checks"
                    defaultMessage="Final checks"
                />
            )
        },
        {
            id: 4,
            label: 'Withdraw funds',
            message: (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.withdraw_funds"
                    defaultMessage="Withdraw funds"
                />
            )
        }
    ];

    return (
        <div className="flex items-center justify-center gap-xs px-l py-xl min-sm:px-0">
            {STEPS_CONFIG.map(({ id, label, message }) => (
                <FundingProgressStep
                    key={id}
                    label={label}
                    message={message}
                    status={
                        step === id
                            ? 'active'
                            : step > id
                              ? 'complete'
                              : 'pending'
                    }
                />
            ))}
        </div>
    );
};
